module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-pickwick-03.1@2x.1c6467b0.jpg";